import React, { useState, useRef, useEffect } from 'react';
import swal from 'sweetalert';
import reportsService from '../../services/reportsService';
import MobilityReports from '../../pages/ReportsPages/MobilityReports/MobilityReports';
import { SITE_KEY } from '../../services/credentialService';
import loadScriptByURL from '../../utils/loadScriptRecapchat';

const initialState = {
  fecha_0: new Date(),
  fecha_1: new Date(),
  captcha: '',
};

const ReportMobility = () => {
  const [loading2, setloasing2] = useState(false);
  const [newDate, setDate] = useState(initialState);
  const [prompt, setPrompt] = useState({
    show: false,
    jobId: '',
    archivo: '',
    token_2f: '',
  });
  const timerToClearSomewhere = useRef(null);

  useEffect(() => {
    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`,
      () => {},
    );
  }, []);

  const handleRequestCSV = () => {
    reportsService
      .putCSVMobility(prompt)
      .then((data) => {
        if (data.data.estado == 'PENDIENTE') {
          setPrompt((prevState) => ({
            ...prevState,
            show: true,
          }));
          setloasing2(true);
        }
        if (data.data.estado == 'FINALIZADO') {
          setPrompt((prevState) => ({
            ...prevState,
            show: false,
          }));
          setloasing2(false);
          window.open(data.data.url);
        }
      })
      .catch(() => {
        setloasing2(false);
      });
  };

  useEffect(() => {
    if (prompt.show) {
      timerToClearSomewhere.current = setInterval(
        () => handleRequestCSV(),
        2000,
      );
    }
    return () => {
      clearInterval(timerToClearSomewhere.current);
    };
  }, [prompt]);

  /*= =======================================================================
  Request OPT
====================================================== ================== */

  const handleRequestOTP = (token) => {
    setloasing2(true);
    reportsService
      .postCSVMobility(token)
      .then((data) => {
        setPrompt({ ...prompt, ...data.data });
        swal('Revisa tu correo electrónico!', {
          icon: 'info',
          content: {
            element: 'input',
            buttons: {
              cancel: true,
              confirm: true,
            },
            attributes: {
              placeholder: 'Ingresa el código OTP que enviamos a tu correo',
              type: 'text',
            },
          },
        }).then((response) => {
          setPrompt((prevState) => ({
            ...prevState,
            token_2f: response,
            show: true,
          }));
        });
      })
      .catch(() => {
        setloasing2(false);
      });
  };

  /*= =======================================================================
  Generate TokenKey
====================================================== ================== */
  const handleOnSumit = (event) => {
    event.preventDefault();
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(SITE_KEY, { action: 'submit' })
        .then((token) => {
          handleRequestOTP({ ...newDate, captcha: token });
        });
    });
  };

  const handleChangePikers = (type, value) => {
    setDate({ ...newDate, [type]: value });
  };

  return (
    <MobilityReports
      newDate={newDate}
      loading2={loading2}
      handleSubmit={handleOnSumit}
      onChangeData={handleChangePikers}
    />
  );
};

export default ReportMobility;
